<div class="center-cell-content">
  <button (click)="editData(params)" title="Edit" *ngIf="isEditVisible" [disabled]="!EditVisible">
    <img src="/assets/tree-structuresvg.svg" height="25" width="20" alt="Edit Icon"/>
  </button>
</div> 